(function () {
    'use strict';

    angular
        .module('ib-pmt-services-http-module')
        .factory('PmtOnBCreditCardsProxy', PmtOnBCreditCardsProxy);

    PmtOnBCreditCardsProxy.$inject = ['$http', '$q'];
    function PmtOnBCreditCardsProxy($http, $q) {
        var service = {
            getCustomerCreditCardsInfo: getCustomerCreditCardsInfo,
            saveCustomerCreditCard: saveCustomerCreditCard
        };

        return service;

        /**
        * Calls HTTP GET method to save credit card Info with rest service
        * @param {string} uri - the http url of rest service
        * @returns {Object.<Promise>} - returns the $http promise. When the promise resolves, it returns an object with the response data and the response status.
        *  When the promise rejects, it returns an object with the response error data and the response error code.
        */
        function getCustomerCreditCardsInfo(uri) {
            return $http.get(uri)
                .then(getCustomerCreditCardsInfoComplete)
            ['catch'](getCustomerCreditCardsInfoFailed);

            function getCustomerCreditCardsInfoComplete(response) {
                return response.data;
            }

            function getCustomerCreditCardsInfoFailed(response) {
                return $q.reject({ data: response.data, errorCode: response.status });
            }
        }


        /**
         *  Calls HTTP PUT method to save credit card Info with rest service
         * @param {string} uri the http url of rest service
         * @param {Object} requestData Object with customer credit card information
         * @returns {Object.<Promise>} - returns the $http promise. When the promise resolves, it returns an object with the response data and the response status.
         * When the promise rejects, it returns an object with the response error data and the response error code.
         */
        function saveCustomerCreditCard(uri, requestData) {

            return $http.post(uri, angular.toJson(requestData))
                .then(getCreditCardsInfoComplete)['catch'](getCreditCardsInfoFailed);

            function getCreditCardsInfoComplete(response) {
                return response.data;
            }

            function getCreditCardsInfoFailed(response) {
                return $q.reject({ data: response.data, errorCode: response.status });
            }
        }
    }
})();